import * as RadioPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { cn } from '#app/utils/misc.js';

export type RadioProps = Omit<React.ComponentPropsWithoutRef<typeof RadioPrimitive.Root>, 'type'> & {
  type?: string;
};

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioPrimitive.Root>
>(({ className, ...props }, ref) => <RadioPrimitive.Root ref={ref} className={cn(className)} {...props} />);

const RadioItem = React.forwardRef<
  React.ElementRef<typeof RadioPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioPrimitive.Item
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-full border border-stone-500 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      className
    )}
    {...props}
  />
));

const RadioIndicator = React.forwardRef<
  React.ElementRef<typeof RadioPrimitive.Indicator>,
  React.ComponentPropsWithoutRef<typeof RadioPrimitive.Indicator>
>(({ className, ...props }, ref) => (
  <RadioPrimitive.Indicator
    ref={ref}
    className={cn(
      'relative flex size-full items-center justify-center after:block after:size-1.5 after:rounded-full after:bg-primary-foreground',
      className
    )}
    {...props}
  />
));

export { RadioGroup, RadioItem, RadioIndicator };
